import { createRoute } from '@tanstack/react-router'
import { z } from 'zod'

import OrderDetailPage from '../pages/OrderDetailPage'
import { orderRoute } from './OrderRoute'

export const orderDetailRoute = createRoute({
  getParentRoute: () => orderRoute,
  component: () => <OrderDetailPage />,
  path: '/$id',
  validateSearch: (search) =>
    z
      .object({
        page: z.number().optional(),
        perPage: z.number().optional(),
        status: z.array(z.string()).optional(),
        paymentStatus: z.array(z.string()).optional(),
        departure: z.string().optional(),
        destination: z.string().optional(),
        departureDateFrom: z.string().optional(),
        departureDateTo: z.string().optional(),
        data: z.string().optional(),
        search: z.string().optional(),
        mode: z.enum(['filter', 'search']).optional()
      })
      .parse(search)
})
